import { http } from '@/core/api';
import { executeRequest } from '@/core/either';
import type { ApiResult } from '@/core/either';
import type {
  NotificationCount,
  NotificationParams,
  NotificationParamsUpdate,
  NotificationResponse,
} from '../types/notification.type';

export const notificationService = {
  /**
   * Obtiene el conteo de notificaciones para el usuario actual.
   * @param params - Parámetros para filtrar el conteo de notificaciones.
   * @returns Promesa con el resultado tipado usando Either (ApiResult<number>).
   */
  getNotificationCount(params: NotificationCount): Promise<ApiResult<number>> {
    return executeRequest(() =>
      http.get<number>('notification/b2b/count', { params })
    );
  },

  /**
   * Obtiene el listado de notificaciones según los filtros proporcionados.
   * @param params - Parámetros para filtrar las notificaciones.
   * @returns Promesa con el resultado tipado usando Either (ApiResult<NotificationResponse>).
   */
  getNotifications(params: NotificationParams): Promise<ApiResult<NotificationResponse>> {
    return executeRequest(() =>
      http.get<NotificationResponse>('notification/b2b/details', { params })
    );
  },

  /**
   * Actualiza una notificación específica.
   * @param payload - Objeto con los datos a actualizar de la notificación (incluye el id).
   * @returns Promesa con el resultado tipado usando Either (ApiResult<NotificationResponse>).
   */
  updateNotification(payload: NotificationParamsUpdate): Promise<ApiResult<NotificationResponse>> {
    return executeRequest(() =>
      http.put<NotificationResponse>(`notification/b2b/${payload.id}`, payload)
    );
  },

  /**
   * Elimina una notificación específica por su id.
   * @param id - Identificador único de la notificación a eliminar.
   * @returns Promesa con el resultado tipado usando Either (ApiResult<void>).
   */
  deleteNotification(id: string): Promise<ApiResult<void>> {
    return executeRequest(() =>
      http.delete(`notification/b2b/${id}`)
    );
  },
}; 